export const PROPOSAL_STORAGE_KEY = 'qbeek-proposal';

// Legacy draft/input demand defaults, not tariff allowances or prices.
const PROPOSAL_DEMAND_DEFAULTS = {
  start: { waiters: 3, training: 10 },
  business: { waiters: 10, training: 20 },
  expert: { waiters: 15, training: 30 },
};

export const getProposalDemandDefaults = code => PROPOSAL_DEMAND_DEFAULTS[code] || { waiters: 0, training: 0 };

export const PROPOSAL_PAGE = {
  proposal: 0,
  calculation: 1,
};

export const PROPOSAL_PAGES_TOTAL = 2;

export const INTEGRATION_COST_PER_VENUE = 15000;

export const PROPOSAL_DATES = {
  validForDays: 14,
  noonOffset: 'T12:00:00',
};
